import { render, staticRenderFns } from "./Checkbox.component.vue?vue&type=template&id=3c4d0b8f&scoped=true"
import script from "./Checkbox.component.vue?vue&type=script&lang=js"
export * from "./Checkbox.component.vue?vue&type=script&lang=js"
import style0 from "./Checkbox.component.vue?vue&type=style&index=0&id=3c4d0b8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d0b8f",
  null
  
)

export default component.exports